

import {useNavigate } from "react-router-dom";

//         if (token) {
//             try {

//                 window.localStorage.setItem('access_token', token)
//                 window.localStorage.getItem('access_token')
//                 console.log('Access token saved in localStorage:', localStorage.getItem('access_token'));
//                 // navigate('/admin'); // Redirect after saving token
//             } catch (error) {
//                 console.error('Error saving token:', error);
//             }
//         } else {
//             console.warn('Access token not found in URL');
//             // navigate('/login'); // Redirect if token is missing
//         }
        
//     }

export const StorageData = () => {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const token = urlParams.get('access_token');

    if (token) {
        try {
            // Save the token to localStorage
            window.localStorage.setItem('access_token', token);
            console.log('Access token saved in localStorage:', localStorage.getItem('access_token'));

            // Clean the URL to remove the token
            urlParams.delete('access_token');
            window.history.replaceState({}, document.title, window.location.pathname);

            // Redirect after saving token (uncomment if needed)
            // navigate('/admin'); 
        } catch (error) {
            console.error('Error saving token:', error);
        }
    } else {
        console.warn('Access token not found in URL');
        // Redirect if token is missing (uncomment if needed)
        // navigate('/login'); 
    }
};



export const CheckStorage = (value:any,statusCode:any) => {
    if(statusCode === 401) {
        // Clear the token from localStorage and redirect to login page
        window.location.href='/login';
    }
};



